import React from 'react';
import BodyRowDraggable, { IBodyRowDraggableProps } from './BodyRowDraggable';
import { BodyRowPure } from '../../BodyRow';

const BodyRowDraggablePure = (props: IBodyRowDraggableProps) => (
  <BodyRowDraggable
    { ...props }
    bodyRowComponent={ BodyRowPure }
  />
);

export default React.memo(BodyRowDraggablePure);
